import type { ICreateUserApiPayload, ICreateUserApiResponse } from '../types/SignUp.api';
import type { ISignUpRequest, ISignUpResponse } from '../types/SignUp';

const SOURCE = 'web-portal';

const toCreateUserPayload = (input: ISignUpRequest): ICreateUserApiPayload => ({
  email: input.email,
  password: input.password,
  source: SOURCE,
  ...(input.referralId ? { referralID: input.referralId } : {}),
});

const toSignUpResponse = (apiResponse: ICreateUserApiResponse): ISignUpResponse => ({
  access_token: apiResponse.accessToken,
  refresh_token: apiResponse.refreshToken,
  expires_in: String(apiResponse.expiresIn),
});

export const SignUpAdapters = {
  toCreateUserPayload,
  toSignUpResponse,
};
